/**
 * @file
 * @prettier
 */

import { InitializeRepaymentOptionsPages } from "./repaymentOptionsPages.js";

export function InitializeSecureBorrowerRepaymentOptionsIDRRepaymentRenewalPage() {
  InitializeRepaymentOptionsPages();
}
